import React from 'react';
import { Box, Spacer, spaceMixin, Heading } from '@zillow/constellation';
import PropTypes from 'prop-types';
import CalculatorForm from '../CalculatorForm/CalculatorForm.js';
import { isEditor } from '../../utils/isEditor.js';
import CalculatorLayout from '../CalculatorLayout/CalculatorLayout.js';
import { omitUndefined } from '../../utils/lodash.js';
import { FieldConfig, DEFAULT_VALUES_SHAPE } from './RefinanceCalculator.utils.js';
export { DEFAULT_VALUES_SHAPE } from './RefinanceCalculator.utils.js';
import { LOAN_TERM_IN_MONTHS, LOAN_PROGRAMS } from '../../utils/zhl-calculator.js';
import RefinanceFields from './RefinanceFields.js';
import SavingsHeader from './SavingsHeader.js';
import RefinanceBarGraph from './RefinanceBarGraph.js';
import RefinanceLegend from './RefinanceLegend.js';
import RefinanceLineGraph from './RefinanceLineGraph.js';

var RefinanceCalculator = function RefinanceCalculator(_ref) {
  var _Object$assign;
  var defaultValues = _ref.defaultValues,
    editorMode = _ref.editorMode,
    _ref$blockInterestRat = _ref.blockInterestRate,
    blockInterestRate = _ref$blockInterestRat === void 0 ? 5 : _ref$blockInterestRat;
  return /*#__PURE__*/React.createElement(Box, {
    as: CalculatorForm,
    fieldStorageKey: "refinanceFields",
    editorMode: editorMode !== null && editorMode !== void 0 ? editorMode : isEditor(),
    defaultValues: Object.assign((_Object$assign = {}, _Object$assign[FieldConfig.loanAmount.name] = 200000, _Object$assign[FieldConfig.rate.name] = blockInterestRate ? blockInterestRate + 0.75 /// Arbitrary amount higher than new fetched rate
    : 5, _Object$assign[FieldConfig.term.name] = LOAN_TERM_IN_MONTHS[LOAN_PROGRAMS.fixed30Year], _Object$assign[FieldConfig.originationYear.name] = new Date().getFullYear() - 6, _Object$assign[FieldConfig.newLoanAmount.name] = 195000, _Object$assign[FieldConfig.newTerm.name] = LOAN_TERM_IN_MONTHS[LOAN_PROGRAMS.fixed30Year], _Object$assign[FieldConfig.newRate.name] = blockInterestRate !== null && blockInterestRate !== void 0 ? blockInterestRate : 4.35, _Object$assign[FieldConfig.fees.name] = 1000, _Object$assign[FieldConfig.cashOut.name] = 0, _Object$assign[FieldConfig.rollFees.name] = false, _Object$assign), omitUndefined(defaultValues))
  }, /*#__PURE__*/React.createElement(Box, {
    as: CalculatorLayout,
    fields: /*#__PURE__*/React.createElement(RefinanceFields, null),
    content: /*#__PURE__*/React.createElement(Box, {
      sx: {
        display: 'flex',
        flexDirection: 'column'
      }
    }, /*#__PURE__*/React.createElement(Spacer, {
      marginBottom: "lg"
    }, /*#__PURE__*/React.createElement(SavingsHeader, null)), ' ', /*#__PURE__*/React.createElement(Box, {
      sx: {
        display: 'flex',
        flexDirection: 'row',
        '@media $lg_lte': {
          flexDirection: 'column'
        }
      }
    }, /*#__PURE__*/React.createElement(RefinanceBarGraph, null), /*#__PURE__*/React.createElement(Box, {
      sx: {
        width: '100%',
        marginBottom: "" + spaceMixin('md'),
        '@media $lg': {
          marginBottom: 0,
          marginLeft: "" + spaceMixin('lg')
        }
      }
    }, /*#__PURE__*/React.createElement(RefinanceLegend, null))), /*#__PURE__*/React.createElement(Box, {
      sx: {
        width: '100%',
        display: 'block',
        '@media $md_lte': {
          display: 'none'
        }
      }
    }, /*#__PURE__*/React.createElement(Heading, {
      level: "4",
      className: "zsg-content_collapsed"
    }, "Total Savings / Break Even"), /*#__PURE__*/React.createElement(RefinanceLineGraph, null)))
  }));
};
RefinanceCalculator.defaultProps = {
  defaultValues: undefined,
  editorMode: undefined
};
RefinanceCalculator.propTypes = process.env.NODE_ENV !== "production" ? {
  defaultValues: PropTypes.shape(DEFAULT_VALUES_SHAPE),
  editorMode: PropTypes.bool
} : {};
var RefinanceCalculator$1 = RefinanceCalculator;

export { RefinanceCalculator$1 as default };
